import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PackageModel, PackageStatus } from '@/models'

interface PackagesRequest {
  buildingId: number
  locations?: string[]
  status?: PackageStatus
  startDate?: number
  endDate?: number
  sort?: string
  limit?: number
  search?: string
  skip?: number
  carrier?: string[]
  perishable?: string
  clientId?: number[]
}

interface GetPackagesResponse {
  results: PackageModel[]
  count: number
  countPending: number
  countReceived: number
  countRequested: number
  countArchived: number
}

export const PACKAGES_BASE_QUERY_KEY = 'useGetPackagesDashboard'
export const getPackagesQueryKey = (data: PackagesRequest) => [PACKAGES_BASE_QUERY_KEY, data]

export const getPackagesDashboard = async (
  params: PackagesRequest,
  signal?: AbortSignal,
): Promise<GetPackagesResponse> => {
  const { locations, ...rest } = params
  const response = await authAPI.get<GetPackagesResponse>(`/packages/dashboard`, {
    params: {
      ...rest,
      // Note: API did not accept locations[]= format
      ...(locations && locations.length > 0 && { location: locations.join(',') }),
    },
    signal,
  })
  return response.data
}

export const useGetPackagesDashboard = (data: PackagesRequest) => {
  return useQuery({
    enabled: data.buildingId > 0,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getPackagesDashboard(data, signal),
    queryKey: getPackagesQueryKey(data),
  })
}
